import CmsBlockQuery from 'Query/CmsBlock.query'
import MenuQuery from 'Query/Menu.query'
import { updateCmsBlocks, updateMenu } from './CmsBlocksAndMenu.action';
import NoErrorQueryDispatcher from "../../util/Request/NoErrorQueryDispatcher";

/**
 * CMS Blocks And Menu Dispatcher
 * @class CmsBlocksAndMenuDispatcher
 * @extends QueryDispatcher
 */
export class CmsBlocksAndMenuDispatcher extends NoErrorQueryDispatcher {

    __construct() {
        super.__construct('CmsBlocksAndMenu');
    }

    onSuccess(data, dispatch) {
        if(data?.menu) {
            dispatch(updateMenu(data.menu));
        }
        if(data?.cmsBlocks) {
            dispatch(updateCmsBlocks(data.cmsBlocks));
        }
    }

    onError(error, dispatch) {
        console.log(error);
        // dispatch(showNotification('error', 'Error fetching CMS Block!', error));
    }

    isMenuRequested({ identifier }) {
        return !!identifier;
    }

    /**
     * Prepare CMS Block and Menu query
     * @param {{identifires: Array, fields: Array, identifier: number}} options An object containing different aspects of query, each item can be omitted
     * @return {Query} CMS Block and Menu query
     * @memberof CmsBlocksAndMenuDispatcher
     */
    prepareRequest(options) {
        return this.isMenuRequested(options)
            ? [MenuQuery.getQuery( options ), CmsBlockQuery.getQuery(options)]
            : [CmsBlockQuery.getQuery(options)];
    }
}

export default new CmsBlocksAndMenuDispatcher();
